import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/AboutUs.css";
import Background from "../images/AnimatedBack.gif";
import Bulb from "../images/Bulb.png";
import Values from "../images/Values.jpg";

function AboutUS() {
  return (
    <>
      <Header />
      <div className="Aboutus">
        <div className="Aboutus-above" style={{height:"260px"}}>
          <img className="Aboutus-img" src={Background} alt="Animated Background" />
          <div className="Aboutus-hero-text">
            <p className="Aboutus-p">About Us</p>
            <p className="Aboutus-p1">
              SETTING NEW STANDARDS IN WEB DEVELOPMENT – BEYOND EXPECTATIONS!
            </p>
          </div>
        </div>

        <div className="Aboutus-content" style={{margin:"auto"}}>
          <p className="Aboutus-p2">
            <strong>Purohit Technosoft </strong> is a globally recognized
            and trusted name in IT services, delivering excellence to clients
            worldwide. Our diverse range of services is designed to redefine and
            strengthen the core of your business operations, helping you achieve
            new heights of success. Our team of skilled experts harnesses the
            latest and most advanced market technologies to{" "}
            <strong>deliver exceptional onsite solutions</strong>
            tailored to your needs. From cutting-edge software development across
            various platforms to bespoke IT services, we empower businesses with
            innovative solutions. <strong>We specialize</strong> in custom web
            design, web development, custom software creation, and mobile
            application development, ensuring that your digital presence and
            operational tools are nothing short of outstanding.
          </p>
          <p className="Aboutus-p2">
            <strong>At Purohit Technosoft Solutions</strong>, we focus on
            providing high-quality services at the best value, coupled with
            comprehensive after-sales support to ensure your satisfaction and
            success. <strong>Partner with us</strong> to experience innovation,
            dedication, and excellence in every project we undertake.{" "}
          </p>

          <div className="Aboutus-main">
            <div className="Aboutus-main1">
              <div className="Aboutus-mission">
                <div className="mission-header">
                  <i className="fa-solid fa-crosshairs mission-icon"></i>
                  <p className="mission-title">Mission</p>
                </div>
                <p>
                  Our mission is simple yet profound: to deliver top-notch
                  solutions with unmatched quality and service. We place customer
                  satisfaction at the heart of everything we do, constantly
                  innovating to enhance the quality of our products and services.
                </p>
                <p>
                  We believe in building long-lasting professional relationships
                  that drive mutual growth and success, striving for a win-win
                  collaboration that benefits both our clients and us.
                </p>
                <p>
                  Our dedication extends beyond our clients to our team, where we
                  foster a workplace culture rooted in exceptional performance,
                  teamwork, and respect for hard work. We don't just aim to meet
                  expectations—we strive to exceed them, ensuring every
                  interaction is a step toward shared success.
                </p>
              </div>
              <img className="Aboutus-main1-img" src={Bulb} alt="Innovation Bulb" />
              <div className="Aboutus-vision">
                <div className="vision-header">
                  <i className="fa-solid fa-hurricane vision-icon"></i>
                  <p className="vision-title">Vision</p>
                </div>
                <p>
                  Our vision is to thrive as a premier IT service provider,
                  continually evolving to meet the demands of a competitive global
                  market. Our work reflects our commitment to professionalism,
                  adaptability, and seamless innovation, guiding our clients
                  toward success every step of the way.
                </p>
                <p>
                  With a team of highly skilled professionals, we bridge the gap
                  between real-world challenges and digital solutions, leveraging
                  years of corporate expertise to deliver impactful results.
                  Driven by a perfect blend of passion and proficiency, our team
                  is dedicated to accelerating your business growth and empowering
                  your journey toward excellence.
                </p>
              </div>
            </div>
            <div className="Aboutus-main2">
              <p className="values-title">Our Values</p>
              <p className="values-subtitle">
                Our perception is to go beyond delivering just a pleasant
                experience. Every action we take is a reflection of the values we
                cherish.
              </p>
              <div className="values-container">
                <img className="values-image" src={Values} alt="Our Values" />
                <div className="value-box value-box1">
                  <p className="value-title">Team spirit</p>
                  <p className="value-description">Together everyone achieves more!</p>
                </div>
                <div className="value-box value-box2">
                  <p className="value-title">Continuous Improvement</p>
                  <p className="value-description">How can we do things better?</p>
                </div>
                <div className="value-box value-box3">
                  <p className="value-title">Customer focus</p>
                  <p className="value-description">Our customer's success is our success.</p>
                </div>
                <div className="value-box value-box4">
                  <p className="value-title">Dedicated & Creative</p>
                  <p className="value-description">Passion and achievement towards achieving goals.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default AboutUS;